<template>
  <div class="page-content page-404">
    <!-- :TODO CONTENT -->
    <div class="content">
      <div class="container">
        <h2>Page 404</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style lang="stylus">
  .page-404 {
    /*TODO: Footer*/
    footer.footer {
      padding-top 15px
      padding-bottom 15px
      min-height 90px
      &:before {
        display none
      }
    }
  }
</style>
